module.exports = __webpack_public_path__ + "img/course_Image_six.62bfa899.png";